import { hateoas } from '@jota-one/http-client'

const createSurveyApi = () => {
  const _http = hateoas({
    baseURL: '/public/survey',
  })

  let endpoints

  const init = async () => {
    const response = await _http.loadIndex('/index')
    endpoints = response.data
  }

  const startSurvey = async (payload) =>
    _http.followLink(
      endpoints,
      'start-survey',
      {},
      {
        method: 'POST',
        data: payload,
      },
    )

  const nextPage = async (payload) =>
    _http.followLink(
      endpoints,
      'next-page',
      {},
      { method: 'POST', data: payload },
    )

  const getTexts = async (language, touchPoint) =>
    _http.followLink(
      endpoints,
      'get-text',
      { language, touchPoint },
      { method: 'GET' },
    )

  return {
    init,
    startSurvey,
    nextPage,
    getTexts,
  }
}

export const surveyApi = createSurveyApi()
